<template>
	<div>
		<div>
			<div style="display: flex; justify-content: space-between">
				<div>
					<el-form :inline="true" class="demo-form-inline" label-position="right" label-width="100px"
						:model="searcheForm">
						<!-- <el-form-item label="消息分类：">
							<el-input placeholder="请输入消息分类关键字" clearable width="180px" v-model="searcheForm.url">
							</el-input>
						</el-form-item> -->
                        <el-form-item label="消息分类:">
							<el-select style="width: 25rem" v-model="searcheForm.url" placeholder="请选择"
								@change="stationIdChange">
								<el-option v-for="item in startOptions" :key="item.key" :label="item.value"
									:value="item.key"></el-option>
							</el-select>
						</el-form-item> 
						<el-button icon="el-icon-search" type="primary" @click="initUsers">搜索</el-button>
						<el-button icon="el-icon-search" type="default" @click="clearForm">清空</el-button>
					</el-form>
				</div>
			</div>
		</div>
		<!-- 表格 start -->
		<div style="margin-top: 30px">
			<el-table :data="orderList" stripe border v-loading="loading" element-loading-text="正在加载..."
				element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)"
				style="width: 100%">
				<el-table-column type="selection" align="center" width="44"></el-table-column>
				<!-- <el-table-column prop="url" label="消息类型" width="160" align="center" fixed="left">
				</el-table-column> -->
				<el-table-column prop="payStatus" label="消息分类" width="200" align="center">
					<template slot-scope="scope">
						<span v-for="(item,index) in startOptions">
							<el-tag v-if="scope.row.url == item.key " type='START_CHARGE'>{{item.value}}</el-tag>
						</span>
						<!-- <el-tag v-if="scope.row.url == 'https://charge.unismartcity.com:8081/batterycar/openApi/v1/device/rechargeRecord'" type='info'>充电记录</el-tag>
						<el-tag v-if="scope.row.url == 'https://charge.unismartcity.com:8081/batterycar/openApi/v1/electricity/monthElectricity'" type="success">月账单</el-tag>
						<el-tag v-if="scope.row.url == 'https://charge.unismartcity.com:8081/batterycar/openApi/v1/device/deviceOfflineUpdateRecord'" type="START_CHARGE">上下线</el-tag>
						<el-tag v-if="scope.row.url == 'HEART_BEAT'" type="">彭浦新村：设备状态</el-tag>
						<el-tag v-if="scope.row.url == 'REAL_TIME'" type="warning">彭浦新村：实时数据</el-tag>
						<el-tag v-if="scope.row.url == 'CHARGE_RECORD'" type="START_CHARGE">彭浦新村：运营数据</el-tag>
						<el-tag v-if="scope.row.url == 'START_CHARGE'" type="START_CHARGE">彭浦新村：开始充电</el-tag>
						<el-tag v-if="scope.row.url == 'STOP_CHARGE'" type="START_CHARGE">彭浦新村：结束充电</el-tag>
						<el-tag v-if="scope.row.url == 'XIAN_CAR_CHARGE'" type="XIAN_CAR_CHARGE">西安-充电数据</el-tag>
						<el-tag v-if="scope.row.url == 'XIAN_ALARM_DATA'" type="XIAN_ALARM_DATA">西安-告警数据</el-tag>
						<el-tag v-if="scope.row.url == 'SHEV-DATA-/internal-api/gateway/receive/charging-report-message'" type="START_CHARGE">上海-充电过程</el-tag>
						<el-tag v-if="scope.row.url == 'SHEV-DATA-/internal-api/gateway/receive/charging-order-message'" type="START_CHARGE">上海-充电订单</el-tag>
						<el-tag v-if="scope.row.url == 'SHEV-DATA-/internal-api/gateway/receive/charging-port-message'" type="XIAN_ALARM_DATA">上海-接口信息</el-tag>
						<el-tag v-if="scope.row.url == 'SHEV-DATA-/internal-api/gateway/receive/charging-pile-message'" type="START_CHARGE">上海-插座信息</el-tag>
						<el-tag v-if="scope.row.url == 'SHEV-DATA-/internal-api/gateway/receive/charging-alarm-message'" type="XIAN_ALARM_DATA">上海-告警数据</el-tag>
						<el-tag v-if="scope.row.url == 'SHEV-DATA-ALARM_DATA_REAL_TIME_01'" type="XIAN_ALARM_DATA">上海-告警数据</el-tag>
						<el-tag v-if="scope.row.url == 'SHEV-DATA-CHARGING_ORDER_02'" type="START_CHARGE">上海-订单信息</el-tag>
						<el-tag v-if="scope.row.url == 'SHEV-DATA-CHARGING_PILE_INFO_03'" type="START_CHARGE">上海-插座信息</el-tag>
						<el-tag v-if="scope.row.url == 'SHEV-DATA-CHARGING_PILE_INTERFACE_04'" type="START_CHARGE">上海-接口信息</el-tag>
						<el-tag v-if="scope.row.url == 'SHEV-DATA-CHARGING_PROCESS_DATA_UPLOAD_05'" type="START_CHARGE">上海-充电过程</el-tag> -->
					</template>
				</el-table-column>
				<el-table-column prop="keyword" label="设备编码/订单号" width="200" align="center"></el-table-column>
				<el-table-column prop="message" label="消息 "  align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.message.length > 100 ">
						 {{scope.row.message.substring(0,100)}} ...
						</div>
						<div v-if="scope.row.message.length <= 100 ">
						 {{scope.row.message}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="result" label="推送结果" width="120" align="center">
					<template slot-scope="scope">
						<div v-if="scope.row.result > 100 ">
						 {{scope.row.result.substring(0,100)}} ...
						</div>
						<div v-if="scope.row.result <= 100 ">
						 {{scope.row.result}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="createdTime" label="创建时间" width="120" align="center"></el-table-column>
				<el-table-column fixed="right" label="操作" width="200" align="center">
					<template slot-scope="scope">
						<el-button @click="showEditEmpView(scope.row)">查看</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div style="display: flex; justify-content: flex-end">
				<el-pagination background @current-change="currentChange" @size-change="sizeChange"
					layout="sizes, prev, pager, next, jumper, ->, total, slot" :total="total"></el-pagination>
			</div>
		</div>
		<!-- 表格 END -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="1000px">
			<div style="height: 40vh; overflow: auto">
				<el-form :model="orderForm" ref="orderDetail" label-position="right" label-width="120px">
					
					<el-col :span="24">
						<el-form-item label="推送记录">
							<el-input type="textarea" clearable rows="10"  v-model="orderForm.message"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="推送结果">
							<el-input type="textarea" clearable rows="10"  v-model="orderForm.result"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="12"></el-col>
					<el-col :span="12"></el-col>
					<el-col :span="12"></el-col>
					<el-col :span="12"></el-col>
				</el-form>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="doOrderDetailUpdate">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		apiListStations
	} from "../charge/charge-equipment";
	import {
		deleteRequest,
		putRequest,
		getRequest,
		postRequest,
	} from "../../utils/api";
	export default {
		name: "OrderList",
		data() {
			return {
				title: "", //模态窗口 标题
				searcheForm: {}, //搜索
				orderList: [], //列表数据
				rolesOptions: [],
				loading: false,
				dialogVisible: false, // 是否显示 模态窗口
				total: 0,
				page: 1,
				size: 10,
				user: {},
				stationList: [],
				stationIdOptions: [],
				startOptions: [{
						key: 'XIAN_CAR_CHARGE',
						value: "西安-充电数据"
					},{
						key: 'XIAN_ALARM_DATA',
						value: "西安-告警数据"
					},{
						key: 'START_CHARGE',
						value: "彭浦新村：开始充电"
					},
					{
						key: 'STOP_CHARGE',
						value: "彭浦新村：停止充电"
					},
					{
						key: 'HEART_BEAT',
						value: "彭浦新村：心跳"
					},
					{
						key: 'CHARGE_RECORD',
						value: "彭浦新村：运营数据"
					},{
						key: 'REAL_TIME',
						value: "彭浦新村：实时数据"
					},
					// {
					// 	key: 'https://charge.unismartcity.com:8081/batterycar/openApi/v1/device/rechargeRecord',
					// 	value: "充电记录"
					// },
					// {
					// 	key: 'https://charge.unismartcity.com:8081/batterycar/openApi/v1/device/deviceOfflineUpdateRecord',
					// 	value: "上下线"
					// },
					// {
					// 	key: 'https://charge.unismartcity.com:8081/batterycar/openApi/v1/electricity/monthElectricity',
					// 	value: "月度报表"
					// },
					// {
					// 	key:'SHEV-DATA-/internal-api/gateway/receive/charging-report-message',
					// 	value:"上海-充电过程"
					// },
					// {
					// 	key:'SHEV-DATA-/internal-api/gateway/receive/charging-order-message',
					// 	value:"上海-订单信息"
					// },
					// {
					// 	key:'SHEV-DATA-/internal-api/gateway/receive/charging-port-message',
					// 	value:"上海-插座接口信息"
					// },
					// {
					// 	key:'SHEV-DATA-/internal-api/gateway/receive/charging-pile-message',
					// 	value:"上海-插座信息"
					// },
					// {
					// 	key:'SHEV-DATA-/internal-api/gateway/receive/charging-alarm-message',
					// 	value:"上海-告警信息"
					// },
					{
						key:'SHEV-DATA-ALARM_DATA_REAL_TIME_01',
						value:"上海-告警信息"
					},
					{
						key:'SHEV-DATA-CHARGING_ORDER_02',
						value:"上海-订单信息"
					},
					{
						key:'SHEV-DATA-CHARGING_PILE_INFO_03',
						value:"上海-插座信息"
					},
					{
						key:'SHEV-DATA-CHARGING_PILE_INTERFACE_04',
						value:"上海-插座接口信息"
					},
					{
						key:'SHEV-DATA-CHARGING_PROCESS_DATA_UPLOAD_05',
						value:"上海-充电过程"
					}
				],
				payStatusList: [{
						status: 0,
						label: "未启动"
					},
					{
						status: 1,
						label: "充电中"
					},
					{
						status: 2,
						label: "已完成"
					},
					{
						status: 3,
						label: "充电失败"
					},
					{
						status: 4,
						label: "故障"
					},
				],
				endModeOptions: [{
						key: 0,
						value: '时间用尽'
					},
					{
						key: 1,
						value: '负载被拔'
					},
					{
						key: 2,
						value: '充满自停'
					},
					{
						key: 3,
						value: '故障自停'
					},
					{
						key: 4,
						value: '功率过载'
					},
					{
						key: 5,
						value: '退费停止'
					},
					{
						key: 6,
						value: '未接负载'
					},
					{
						key: 7,
						value: '充实过长'
					},
					{
						key: 8,
						value: '电量用尽'
					},
					{
						key: 9,
						value: '在线停止'
					},
				],
				orderForm: {},
				userForm: {
					name: [{
							required: true,
							message: "请输入姓名",
							trigger: "blur"
						},
						{
							min: 2,
							max: 15,
							message: "长度在 2 到 15 个字符",
							trigger: "blur",
						},
					],
					phone: [{
							required: true,
							message: "请输入手机号",
							trigger: "blur"
						},
						{
							min: 11,
							max: 11,
							message: "长度是 11  个字符",
							trigger: "blur"
						},
					],
					gender: [{
						required: true,
						message: "请选择性别",
						trigger: "change"
					}],
					address: [{
						required: true,
						message: "请填写地址",
						trigger: "blur"
					}],
					remark: [{
						required: true,
						message: "请填写备注",
						trigger: "blur"
					}],
				},
			};
		},
		mounted() {
			this.initUsers();
			this.initSelectStations();
			getRequest("/api/system/basic/permiss/").then((res) => {
				this.rolesOptions = res;
			});
		},
		methods: {
			clearForm() {
				this.searcheForm={};

			},
			initSelectStations() {
				apiListStations({
					page: 1,
					size: 9999
				}).then((resp) => {
					if (resp.status == 200) {
						const data = resp.data;
						this.stationList = data.list;
						this.stationList.forEach((element) => {
							this.stationIdOptions.push({
								label: element.stationName,
								value: element.id,
							});
						});
					}
				});
			},
			stationIdChange(v) {
				console.log("U Selected " + v);
				this.searcheForm.url=v;
			},
			doRefund(row) {
				this.$confirm("此操作将费用退回客户, 操作后无法撤回，是否继续", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					}).then(() => {
						getRequest("/api/order/refund/" + row.id).then((resp) => {
							if (resp.status == 200) {
								Message.error({
									message: resp.msg
								});
							} else {
								Message.error({
									message: resp.msg
								});
							}
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			payStatus(row, column) {
				const status = row.chargingStatus;
				if (status === 0) {
					return "未启动";
				}
				if (status === 1) {
					return "充电中";
				}
				if (status === 2) {
					return "已完成";
				}
				if (status === 3) {
					return "充电失败";
				}
				if (status === 4) {
					return "故障";
				}
			},
			doOrderDetailUpdate() {
				this.dialogVisible = false;
			},
			//编辑用户按钮
			showEditEmpView(data) {
				this.title = "推送记录详情";
				this.orderForm = data;
				this.dialogVisible = true;
			},
			//添加用户 && 更新用户
			doAddUser() {
				let url;
				if (this.user.id) {
					url = putRequest(`/api/system/user/`, this.user);
				} else {
					url = postRequest(`/api/system/user/addUser`, this.user);
				}
				this.$refs["userForm"].validate((valid) => {
					if (valid) {
						url.then((resp) => {
							if (resp) {
								this.dialogVisible = false;
								this.initUsers();
							}
						});
					}
				});
			},
			// 页大小
			sizeChange(currentSize) {
				this.size = currentSize;
				this.initUsers();
			},
			// 选择页
			currentChange(currentPage) {
				this.page = currentPage;
				this.initUsers("advanced");
			},
			// 查询用户列表
			initUsers(type) {
				this.loading = true;
				postRequest(
					`/api/third-party/data/page?page=${this.page}&size=${this.size}`,
					this.searcheForm
				).then((resp) => {
					this.loading = false;
					if (resp) {
						this.orderList = resp.data.list;
						this.total = resp.data.total;
					}
				});
			},
			formatEndMode(row, col, cellvalue, index) {
				let _text = '';
				if (row.reason != undefined) {
					this.endModeOptions.forEach(e => {
						if (e.key == parseInt(row.reason)) {
							_text = e.value;
						}
					})
				}
				return _text;
			},
			formatStartType(row, col, cellvalue, index) {
				let _text = '';
				if (row.reason != undefined) {
					this.startOptions.forEach(e => {
						if (e.key == parseInt(row.startType)) {
							_text = e.value;
						}
					})
				}
				return _text;
			}
		},
	};
</script>

<style>
	/* 可以设置不同的进入和离开动画 */
	/* 设置持续时间和动画函数 */
	.slide-fade-enter-active {
		transition: all 0.8s ease;
	}

	.slide-fade-leave-active {
		transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
	}

	.slide-fade-enter,
	.slide-fade-leave-to

	/* .slide-fade-leave-active for below version 2.1.8 */
		{
		transform: translateX(10px);
		opacity: 0;
	}
</style>
